import { useId } from 'react';
import { Search } from 'lucide-react';

import styles from './SearchInput.module.css';

export interface SearchInputProps {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  disabled,
  size = 'md',
  className,
}: SearchInputProps) {
  const id = useId();
  const cls = [styles.wrap, size === 'sm' && styles.sm, disabled && styles.disabled, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cls}>
      <Search size={size === 'sm' ? 13 : 14} strokeWidth={1.5} aria-hidden="true" />
      <input
        id={id}
        className={styles.input}
        type="search"
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}
